{
	"common": {
		"cancel": "Cancelar",
		"first-name": "Nombre",
		"last-name": "Apellido",
		"optional": "Opcional",
		"username": "Nombre de usuario",
		"back": "Atrás",
		"skip": "Omitir",
		"save": "Guardar",
		"search": "Buscar"
	},
	"dialog": {
		"no": "No",
		"yes": "Sí"
	},
	"contacts-select": {
		"input-search-label": "Todos los contactos",
		"list-title": "Buscar contactos"
	},
	"stepper": {
		"steps-of-total": "{{completed}} de {{total}}"
	},
	"profile-photo-picker": {
		"change-photo": "Cambiar foto",
		"replace-photo": "Reemplazar foto",
		"upload-photo": "Subir foto"
	},
	"editable-items": {
		"add-information": "Agregar información"
	},
	"edit-profile-form": {
		"critical": "Crítico",
		"positive": "Preferencias",
		"negative": "Desafíos",
		"tooltip": {
			"critical": "Información vital para garantizar un cuidado seguro y adecuado",
			"positive": "Gustos e intereses del destinatario del cuidado para brindar un cuidado personalizado",
			"negative": "Cosas a tener en cuenta para evitar molestias"
		},
		"email": "Correo electrónico",
		"about-me": "Acerca de mí",
		"restricted-access": "Acceso restringido"
	},
	"crop-photo-modal": {
		"move-and-scale-the-photo": "Mueva y escale para seleccionar el área de la foto que desea usar.",
		"title": "Ajustar el área de la foto"
	},
	"table": {
		"no-data": "Sin datos"
	},
	"error-boundary": {
		"whoops-something-went-wrong": "Vaya, algo salió mal.",
		"please-either-refresh-the-page-or-try-again-later": "Por favor, actualice la página o intente nuevamente más tarde.",
		"refresh": "¿Actualizar?"
	},
	"autocomplete-input": {
		"placeholder": "Tipo para buscar",
		"add-value": "Agregar \"{{value}}\""
	},
	"tags-editor": {
		"label": "Etiquetas",
		"placeholder": "Escriba para buscar etiquetas",
		"add-tag": "Agregar etiqueta \"{{value}}\""
	},
	"form-period-control": {
		"period": {
			"day_one": "{{count}} día",
			"day_other": "{{count}} días",
			"custom": "Customizar"
		}
	}
}
